import {
  ADDRESS_LIST_ATTEMPT,
  ADDRESS_LIST_SUCCESS,
  ADDRESS_LIST_FAILED,
  ///////////////////////
  ADDRESS_SAVE_ATTEMPT,
  ADDRESS_SAVE_SUCCESS,
  ADDRESS_SAVE_FAILED,
} from "../types/addressTypes";

const INITIAL_STATE = {
  loading: false,
  saving: false,
  list: [],
  max: 5,
  error: "",
};

function address(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADDRESS_LIST_ATTEMPT:
      return { ...state, loading: true, error: "" };

    case ADDRESS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.data.list || [],
        max: action.data.max || 5,
        error: "",
      };

    case ADDRESS_LIST_FAILED:
      return { ...state, loading: false, error: action.error };

    case ADDRESS_SAVE_ATTEMPT:
      return { ...state, saving: true, error: "" };

    case ADDRESS_SAVE_SUCCESS:
      return {
        ...state,
        saving: false,
        list: action.data.list || [],
        max: action.data.max || state.max,
        error: "",
      };

    case ADDRESS_SAVE_FAILED:
      return { ...state, saving: false, error: action.error };

    default:
      return state;
  }
}

export default address;
